import { useState } from 'react';
import BgImg from './../assets/BGSignUp.png';
import logo from './../assets/LogoGreen.png';
import Agency from './../assets/Agency.png';
import Myself from './../assets/Myself.png';
import Brand from './../assets/Brand.png';
import Property from './../assets/Property.png';
import AgencySelect from './../assets/AgencySelect.png';
import MyselfSelect from './../assets/MyselfSelect.png';
import BrandSelect from './../assets/BrandSelect.png';
import PropertySelect from './../assets/PropertySelect.png';
import Google from './../assets/Google.png';
import Apple from './../assets/Apple.png';
import Facebook from './../assets/Facebook.png';
import Linkedin from './../assets/Linkedin.png';
import ProfilePicture from './../assets/ProfilePicture.png';

type Props = {}

function SignUp({ }: Props) {
    // Estado para la opción seleccionada y el paso actual
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [accountCreationMethod, setAccountCreationMethod] = useState<string | null>(null);
    const [step, setStep] = useState<number>(1); // Controla el paso actual del proceso

    // Opciones iniciales
    const options = [
        { type: 'Myself', img: Myself, imgSelect: MyselfSelect},
        { type: 'Agency', img: Agency, imgSelect: AgencySelect},
        { type: 'Brand', img: Brand, imgSelect: BrandSelect},
        { type: 'Property', img: Property, imgSelect: PropertySelect},
    ];

    // Manejo del clic en una opción
    const handleOptionClick = (type: string) => {
        setSelectedOption(type);
    };

    // Manejo del clic en "Next"
    const handleNextClick = () => {
        if (selectedOption) {
            setStep(step + 1); // Avanza al siguiente paso
        }
    };

    // Manejo del clic en "Back"
    const handleBackClick = () => {
        if (selectedOption) {
            setStep(step - 1); // Avanza al siguiente paso
        }
    };

    // Configuración dinámica de campos para Step 3
    const step3Fields: { [key: string]: { label: string; placeholder: string; type: string }[] } = {
        Myself: [
            { label: 'Full Name', placeholder: 'Enter your full name', type: 'text' },
            { label: 'Email Address', placeholder: 'Enter your email', type: 'email' },
        ],
        Agency: [
            { label: 'Agency Name', placeholder: 'Enter your agency name', type: 'text' },
            { label: 'Contact Person', placeholder: 'Enter contact person name', type: 'text' },
            { label: 'Phone Number', placeholder: 'Enter phone number', type: 'text' },
        ],
        Brand: [
            { label: 'Brand Name', placeholder: 'Enter your brand name', type: 'text' },
            { label: 'Website', placeholder: 'Enter your website URL', type: 'text' },
            { label: 'Email Address', placeholder: 'Enter your email', type: 'email' },
        ],
        Property: [
            { label: 'Property Name', placeholder: 'Enter property name', type: 'text' },
            { label: 'Location', placeholder: 'Enter property location', type: 'text' },
            { label: 'Owner Name', placeholder: 'Enter owner name', type: 'text' },
        ],
    };

    return (
        <div className='relative w-screen overflow-hidden h-fit'>
            <img src={BgImg} className='w-full h-screen object-cover' />
            {step === 1 && (
                <> {/* Paso 1: Which best describes you? */}
                    <div className='absolute inset-0 flex flex-col z-20 my-12 mx-64 items-center backdrop-blur-sm rounded-[20px] py-[50px] px-[55px] h-fit'>
                        <img src={logo} className='w-24 h-auto' />
                        <div className='flex flex-col w-full mt-8'>
                            <span className='text-white text-2xl font-medium'>Which best describes you?</span>
                            <span className='text-gray30 font-regular text-base mt-2'>Select the option that applies to you.</span>
                        </div>
                        <div className='flex flex-wrap justify-between gap-4 mt-6'>
                            {options.map((option) => (
                                <button
                                    key={option.type}
                                    onClick={() => handleOptionClick(option.type)}
                                    className={`flex flex-col w-[190px] justify-center items-center border-[1px] rounded-[10px] p-[20px] gap-4 
                                    ${selectedOption === option.type ? 'border-neonGreen bg-[#111A00] bg-opacity-40' : 'border-white'}`}>
                                    {selectedOption === option.type ? <img src={option.imgSelect} className='h-24 w-auto' />  : <img src={option.img} className='h-24 w-auto' />}
                                        <span className={`font-medium text-[18px] ${selectedOption === option.type ? 'text-neonGreen' : 'text-white'}`}>{option.type}</span>
                                </button>
                            ))}
                        </div>
                        <div className='flex justify-end w-full my-4'>
                            <button
                                onClick={handleNextClick}
                                disabled={!selectedOption} // Deshabilita el botón si no hay una opción seleccionada
                                className={`py-2.5 px-3.5 rounded-md w-28 mt-4 font-bold
                                ${selectedOption ? 'bg-neonGreen text-black' : 'bg-gray text-gray30 cursor-not-allowed'}`}>
                                    Next
                            </button>
                        </div>
                        <div className='flex justify-center w-full gap-2'>
                            <div className='h-[10px] w-[20px] bg-neonGreen rounded-full'></div>
                            <div className='h-[10px] w-[10px] bg-gray30 rounded-full'></div>
                            <div className='h-[10px] w-[10px] bg-gray30 rounded-full'></div>
                        </div>
                    </div>
                </>)}

                {step === 2 && (
                    <>{/* Paso 2: Create your account */}
                    <div className='absolute inset-0 flex flex-col w-3/6 z-20 backdrop-blur-sm rounded-[20px] py-2 px-[150px] h-screen'>
                        {/*<img src={logo} className='w-24 h-auto' />*/}
                        <span className='text-white text-lg font-medium mt-[50px]'>Create your account</span>
                        <span className='text-gray30 font-regular text-base mt-2'>Choose a method to create your account.</span>
                        <div className='flex flex-wrap justify-between gap-4 mt-[50px]'>
                            <button className='bg-white py-3 px-3 rounded-xl'>
                                <img src={Google} className='size-[22px]' />
                            </button>
                            <button className='bg-white py-3 px-3 rounded-xl'>
                                <img src={Apple} className='size-[22px]' />
                            </button>
                            <button className='bg-white py-3 px-3 rounded-xl'>
                                <img src={Facebook} className='size-[22px]' />
                            </button>
                            <button className='bg-white py-3 px-3 rounded-xl'>
                                <img src={Linkedin} className='size-[22px]' />
                            </button>
                        </div>
                        <div className='flex flex-row gap-4 items-center my-[20px]'>
                            <div className='flex flex-1 h-[1px] bg-gray30'></div>
                            <span className='text-gray30 text-base'>or</span>
                            <div className='flex flex-1 h-[1px] bg-gray30 w-auto'></div>
                        </div>
                        <div className="flex flex-col w-full">
                            <span className="font-bold text-base text-white mb-1">Email address</span>
                            <input
                                className="bg-white py-2 px-4 rounded-md text-[#55646B] font-regular"
                                placeholder="Type your email"
                                type="email"
                                id="email"
                            />
                        </div>
                        <div className="flex flex-col w-full mt-[20px]">
                            <span className="font-bold text-base text-white mb-1">Password</span>
                            <input
                                className="bg-white py-2 px-4 rounded-md text-[#55646B] font-regular"
                                placeholder="Create a password"
                                type="password"
                                id="password"
                            />
                        </div>
                        <div className='flex w-full mt-[40px]'>
                            <button className='text-base text-gray30 font-regular mr-[30px]'
                            onClick={handleBackClick}>
                                Back
                            </button>
                            <button
                                onClick={handleNextClick}
                                className='bg-neonGreen py-2.5 px-3.5 rounded-md w-full mt-4 text-black font-bold'
                            >
                                Next
                            </button>
                        </div>
                        <span className='font-regular text-gray30 text-base mt-[40px] mb-[20px] text-center'>Already have an account? <a className='text-neonGreen'>Login</a></span>
                        <div className='flex justify-center w-full gap-2'>
                            <div className='h-[10px] w-[10px] bg-gray30 rounded-full'></div>
                            <div className='h-[10px] w-[20px] bg-neonGreen rounded-full'></div>
                            <div className='h-[10px] w-[10px] bg-gray30 rounded-full'></div>
                        </div>
                        </div>
                    </>
                )}

{step === 3 && (
    <div className='absolute inset-0 flex flex-col z-20 my-12 mx-64 items-center backdrop-blur-sm rounded-[20px] py-[50px] px-[55px] h-fit'>
        <span className='text-white text-2xl font-medium'>Complete your profile</span>
        <span className='text-gray30 font-regular text-base mt-2'>Provide the necessary details below.</span>
        <div className='flex flex-col w-full gap-4 mt-6'>
        {selectedOption && accountCreationMethod &&
            step3Fields[selectedOption as keyof typeof step3Fields]?.map((field, index) => (
                <div key={index} className='flex flex-col'>
                    <label className='text-gray30 text-sm font-medium'>{field.label}</label>
                    <input
                        type={field.type}
                        placeholder={field.placeholder}
                        className='border-[1px] border-gray30 rounded-[10px] p-2 text-sm text-black'
                    />
                </div>
            ))}
        </div>
        <div className='flex justify-between mt-8 w-full'>
            <button onClick={handleBackClick} className='text-white bg-gray30 px-4 py-2 rounded-[10px]'>
                Back
            </button>
            <button onClick={handleNextClick} className='text-white bg-primary px-4 py-2 rounded-[10px]'>
                Next
            </button>
        </div>
    </div>
)}

            
        </div>
    );
}

export default SignUp;
